const apiGateway = 'http://localhost:8090';
export const environment = {
  api: 'api',
  url: 'https://staging.checkout-sdk.cydeo.com',
  shopUrl: 'https://staging.checkout-backend.cydeo.com/api/v1',
  stripeKey: 'pk_test_51IGX5yCtKIAKC0qWzm3SJ0Gwqr6xGSnQXLSO11fqlIqtgtsR5Oq0nG7qlTPU0XEVdjIcooZeQ7C3rQstP93aJQCH00SGFcNp9q',
  payment_method_configuration: 'pmc_1OWQoGCtKIAKC0qW9ibYQ6OZ',
}
